import {Injectable, OnDestroy} from "@angular/core";
import {first, ReplaySubject, Subject, Subscription, timer} from "rxjs";
import {ServerStatus, ServerStatusData} from "./server-status.data";
import {BIService} from "../bi.service";
import {Config} from "../../../config";
import {ConfigurationService} from "@fedeltapointofsale/data-client";

/**
 * Server status model to track the status of the BI server
 */
@Injectable()
export class ServerStatusModel implements OnDestroy {

    public statusUpdate$: Subject<ServerStatusData> = new ReplaySubject<ServerStatusData>(1);

    public status: ServerStatusData;

    private subscription: Subscription;

    constructor(
        private biService: BIService,
        private configService: ConfigurationService
    ) {
        this.initPoll();
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    isInitialised(): boolean {
        return this.status && this.status.status === ServerStatus.INITIALISED;
    }

    isInitialising(): boolean {
        return this.status && this.status.status !== ServerStatus.INITIALISED;
    }

    private initPoll(delay?: boolean): void {
        this.configService.getBoolean(Config.BI_ENABLED).then(biEnabled => {
            if (biEnabled) {
                this.subscription = timer(delay ? 3000 : 0).pipe(first()).subscribe(() => this.checkStatus());
            }
        });
    }

    private checkStatus(): void {
        this.biService.getServerStatus().then((status: ServerStatusData) => {
            console.log(status.status);
            if (status.status === ServerStatus.INITIALISING) {
                this.initPoll(true);
            }
            this.status = status;
            this.statusUpdate$.next(status);
        }).catch((error) => {
            console.log("failed to check BI Server Status...");
            console.log(error);
            this.status = new ServerStatusData();
            this.status.status = ServerStatus.FAILED;
            this.initPoll(true);
        });
    }


}
